import * as React from 'react';
import { styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { DatePickerV2, TextV2 } from '@insights-ltd/design-library/components';
import { IDeadlineFilter } from 'types/job';
import { dateFromISOToLocal, fromLocalFormatToDateTime } from 'utils/utils';
import { DATE_GLOBAL_FORMAT } from 'variables';

interface IPropsType {
  deadline: IDeadlineFilter;
  onDeadlineChange: (
    date: string | undefined,
    type: 'startDate' | 'endDate',
  ) => void;
}

const StyledText = styled(TextV2)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

const DeadlineFilter = ({ deadline, onDeadlineChange }: IPropsType) => {
  const startDate = deadline.startDate
    ? fromLocalFormatToDateTime(deadline.startDate)
    : undefined;
  const endDate = deadline.endDate
    ? fromLocalFormatToDateTime(deadline.endDate)
    : undefined;
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
      }}
    >
      <div>
        <DatePickerV2
          disablePast
          format={DATE_GLOBAL_FORMAT}
          labelText="Date From"
          maxDate={startDate ? endDate : undefined}
          onChange={(date: any) =>
            onDeadlineChange(dateFromISOToLocal(date?.toISO()), 'startDate')
          }
          sx={{
            width: '100%',
          }}
          value={startDate}
        />
      </div>
      <StyledText variant="body1">TO</StyledText>
      <div>
        <DatePickerV2
          disablePast
          format={DATE_GLOBAL_FORMAT}
          labelText="Date To"
          minDate={endDate ? startDate : undefined}
          onChange={(date: any) =>
            onDeadlineChange(dateFromISOToLocal(date?.toISO()), 'endDate')
          }
          sx={{
            width: '100%',
          }}
          value={endDate}
        />
      </div>
    </Grid>
  );
};

export default DeadlineFilter;
